import * as THREE from "three"

/** Roughness/metalness match scene object meshes in engine.addObject. */
const MESH_ROUGHNESS = 0.55
const MESH_METALNESS = 0.08

/**
 * Character stand-in from primitives (no assets).
 * Local Y spans ~[-H/2, H/2] like a centered cylinder; group still sits at y = H/2 in world.
 */
export function buildCharacterMannequin(size: [number, number, number], color: string | number): THREE.Group {
  const H = Math.max(size[1], 0.1)
  const footSpan = Math.max(size[0], size[2], 0.05)
  const bodyR = footSpan * 0.22
  const headR = H * 0.12
  const torsoH = H * 0.36
  const legH = H * 0.38
  const legR = H * 0.07
  const armH = H * 0.32
  const armR = H * 0.05
  const legSpread = bodyR * 0.55
  const neck = H * 0.02

  const root = new THREE.Group()
  root.name = "characterMannequin"

  const addPart = (geometry: THREE.BufferGeometry, x: number, y: number, z: number) => {
    const mesh = new THREE.Mesh(
      geometry,
      new THREE.MeshStandardMaterial({
        color,
        roughness: MESH_ROUGHNESS,
        metalness: MESH_METALNESS,
      }),
    )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.set(x, y, z)
    root.add(mesh)
  }

  const feetY = -H / 2
  const legCy = feetY + legH / 2
  const torsoCy = feetY + legH + torsoH / 2
  const headCy = feetY + legH + torsoH + neck + headR
  const shoulderY = feetY + legH + torsoH * 0.75
  const armCy = shoulderY - armH / 2
  const armX = bodyR + armR * 1.2

  addPart(new THREE.SphereGeometry(headR, 16, 12), 0, headCy, 0)
  addPart(new THREE.CylinderGeometry(bodyR, bodyR * 0.92, torsoH, 16), 0, torsoCy, 0)
  addPart(new THREE.CylinderGeometry(legR, legR * 0.9, legH, 12), -legSpread, legCy, 0)
  addPart(new THREE.CylinderGeometry(legR, legR * 0.9, legH, 12), legSpread, legCy, 0)
  addPart(new THREE.CylinderGeometry(armR, armR, armH, 10), -armX, armCy, 0)
  addPart(new THREE.CylinderGeometry(armR, armR, armH, 10), armX, armCy, 0)

  return root
}
